import "./articles.css";

import { useQuery } from "@tanstack/react-query";
import React from "react";
import { useParams } from "react-router-dom";

import Layout from "./Layout";

function ArticleContent() {
	const { slug } = useParams();

	// https://dproz.joeeverest.space/wp-json/wp/v2/posts?slug=accountant

	const { data, isLoading } = useQuery({
		queryKey: ["article", slug],
		queryFn: async () => {
			const res = await fetch(`https://dproz.joeeverest.space/wp-json/wp/v2/posts?slug=${slug}`);
			if (!res.ok) {
				throw new Error(`Failed to fetch article: ${res.status}`);
			}
			const article = await res.json();
			return article;
		},
	});

	if (isLoading) {
		return <div>Loading...</div>;
	}
	if (!data || data.length === 0) {
		return <div>Article not found</div>;
	}

	return (
		<Layout>
			<section className="max-w-7xl mx-auto px-4 md:px-8 py-16 bg-white">
				<div className="">
					<ul className="flex items-center space-x-2 text-gray-500">
						<li>Explore Careers</li>
						<li className="text-gray-400">/</li>
						<li className="text-gray-700">{data[0].title.rendered}</li>
					</ul>
				</div>

				<div className="mt-8">
					<h1 className="text-3xl font-bold mb-4">{data[0].title.rendered}</h1>

					<div
						className="text-gray-700 article-content"
						dangerouslySetInnerHTML={{ __html: data[0].content.rendered }}
					/>
				</div>
			</section>
		</Layout>
	);
}

export default ArticleContent;
